/** Títulos y redactor de cada capítulo de la DIA — fuente única compartida por el chat
 *  de Andrés y la pestaña de previsualización. */
export const CAP_INFO: Record<string, { titulo: string; agente: string }> = {
  cap1: { titulo: 'Cap. 1 — Descripción de Proyecto', agente: 'Roberto' },
  cap2: { titulo: 'Cap. 2 — Antecedentes Art. 11', agente: 'Diamela' },
  cap3: { titulo: 'Cap. 3 — Legislación + PAS', agente: 'Fernanda' },
  cap4: { titulo: 'Cap. 4 — PPP Regional y Comunal', agente: 'Tomás' },
  cap5: { titulo: 'Cap. 5 — Planes estratégicos', agente: 'Camila' },
  cap6: { titulo: 'Cap. 6 — Negociaciones', agente: 'Ignacio' },
  cap7: { titulo: 'Cap. 7 — Compromisos Voluntarios', agente: 'Valentina' },
  cap8: { titulo: 'Cap. 8 — Certificación RCA', agente: 'Matías' },
  cap9: { titulo: 'Cap. 9 — Fichas Resumen', agente: 'Josefa' },
  cap10: { titulo: 'Cap. 10 — Listado de Profesionales', agente: 'Andrea' },
  cap11: { titulo: 'Cap. 11 — Seguimiento de Variables', agente: 'Cristóbal' },
  cap12: { titulo: 'Cap. 12 — Monitoreo Participativo', agente: 'Paula' },
  cap13: { titulo: 'Cap. 13 — Firma de la Declaración', agente: 'Rodrigo' },
  cap14: { titulo: 'Cap. 14 — Resumen Ejecutivo', agente: 'Sofía' },
};

export const capInfo = (c: string) => CAP_INFO[c] ?? { titulo: c, agente: '' };
